import React, { useRef, useEffect } from 'react'

import useInView from '../hooks/useInView'
import { useControlledTimeline } from '../hooks/animation'

const ShowCells = props => {
  const [setInViewRef, inView] = useInView()
  const tl = useControlledTimeline({}, inView)
  const wrapperRef = useRef()

  useEffect(() => {
    tl.staggerFrom(
      wrapperRef.current.querySelectorAll('.LogoCell'),
      1,
      { opacity: 0, transformOrigin: 'center', scale: 0.7 },
      0.1
    )
  }, [])

  return (
    <div
      ref={ref => {
        wrapperRef.current = ref
        setInViewRef(ref)
      }}
      {...props}
    />
  )
}

export default ShowCells
